module.exports = __webpack_public_path__ + "static/img/LA.1d648980.svg";